module.exports = __webpack_public_path__ + "img/2025-0416-03-02.1b27296d.png";